import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20fashion%20collage%20composition%20featuring%20scattered%20lifestyle%20product%20elements%20sneakers%20leather%20accessories%20textile%20textures%20in%20warm%20earthy%20tones%20beige%20terracotta%20cream%20sand%20colors%20soft%20blurred%20depth%20of%20field%20editorial%20aesthetic%20with%20gentle%20gradient%20lighting%20creative%20contemporary%20design&width=1800&height=900&seq=hero-bg-v2&orientation=landscape&nocache=true"
          alt="OOPBUY Spreadsheet lifestyle products"
          className="w-full h-full object-cover object-top"
        />
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35 z-[1]"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight tracking-tight">
          {t('hero.title')}
        </h1>
        <p className="text-base md:text-lg text-white/85 mb-10 max-w-2xl mx-auto leading-relaxed font-light">
          {t('hero.subtitle')}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 text-base font-semibold text-background-50 bg-primary-500 rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            {t('hero.cta')}
            <i className="ri-arrow-right-up-line"></i>
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 text-base font-medium text-white border border-white/40 rounded-full hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            {t('hero.cta_secondary')}
          </a>
        </div>
      </div>
    </section>
  );
}